import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import { useTranslate } from 'src/locales';
import { CallOutcome } from 'src/services/call-lists/call-lists.types';

import Iconify from 'src/components/iconify';

import { OUTCOMES, OUTCOME_ICON, OUTCOME_COLOR } from '../utils';

// ----------------------------------------------------------------------

type Props = {
  value: CallOutcome | null;
  onChange: (outcome: CallOutcome) => void;
  disabled?: boolean;
};

export default function OutcomeButtons({ value, onChange, disabled }: Props) {
  const { t } = useTranslate();

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap role="radiogroup" aria-label={t('call_lists.outcome')}>
      {OUTCOMES.map((outcome) => {
        const selected = value === outcome;
        const tone = OUTCOME_COLOR[outcome];
        const color = tone === 'default' ? 'inherit' : tone;
        return (
          <Button
            key={outcome}
            size="small"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            color={color}
            variant={selected ? 'contained' : 'outlined'}
            startIcon={<Iconify icon={OUTCOME_ICON[outcome]} width={16} />}
            onClick={() => onChange(outcome)}
            data-testid={`call-outcome-${outcome}`}
          >
            {t(`call_lists.outcomes.${outcome}`)}
          </Button>
        );
      })}
    </Stack>
  );
}
